import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var RoundIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 60 60" }),
    React.createElement("circle", { cx: 31, cy: 30, r: 28, fill: "#131314" }),
    React.createElement("path", { d: "M30.86 47.89c-9.05 0-16.39-7.34-16.39-16.39s7.34-16.39 16.39-16.39 16.39 7.34 16.39 16.39-7.34 16.39-16.39 16.39Zm0-31.15c-8.15 0-14.76 6.61-14.76 14.76s6.61 14.76 14.76 14.76 14.76-6.61 14.76-14.76-6.61-14.76-14.76-14.76Z", style: {
            fill: "#fff",
        } }))); };

export default RoundIcon;
